<template>
	<v-toolbar
		color="rgba(0, 0, 0, 0)"
		height="150"
		:elevation="0"
	>
		<v-row align="end" justify="end">
			<template v-if="isManager">
				<v-col cols="6" >
					<v-row
						v-if="isConnected"
						justify="center"
					>
						<div class="navigation">
              <v-btn text @click="updateTranslate" :disabled="disableBtnTranslate">עדכון קובץ תרגום</v-btn>
							<div
								v-for="(route, index) in routes"
								:key="route.name"
								class="block"
							>
								<span
									v-if="index"
									class="link"
								>|</span>

								<v-btn
									text
									:to="route"
									class="red--text"
								>
									<span class="link">{{ route.title }}</span>
								</v-btn>
							</div>
						</div>
					</v-row>
				</v-col>
			</template>
		</v-row>

	</v-toolbar>
</template>

<script>

export default {
	name: "TopToolbar",
	components: {},
	props: {
		value: {},
		routes: {
			type: Array,
			default: () => [],
		},
		user: {},
		// isManager: { type: Boolean },
		isConnected: { type: Boolean },
	},
	data () {
		return {
			open: true,
      disableBtnTranslate : false
		};
	},
	computed: {
		organization () {
			return this.$store.state.CurrentOrg.organization;
		},

		config () {
			return this.$store.state.ConfigModule;
		},
		companyLogo () {
			return this.config.app.logo;
		},
		isManager(){
			return this.$store.getters.isManager;
		}
	},
  methods: {
    async updateTranslate() {
      this.disableBtnTranslate = true;
      const link = "/api/admin/translate";
      try {
        const response = await fetch(link);
        const json = await response.json();
        if(json.success)
          alert("לתרגום לוקח לפחות 7 דקות להתעדכן, יש לבצע רענון חזק");
        else
          alert("שגיאה");
      }
      catch (e) {
        alert("שגיאה")
      }

    }
  },
	watch: {
		value: {
			immediate: true,
			handler () {
				this.open = this.value;
			},
		},
		open: {
			immediate: true,
			handler (newValue) {
				if (this.value !== newValue) {
					this.$emit("close");
				}
			},
		},

	},

};
</script>

<style scoped>
	.admin {
		color: #2f5dab;
		font-size: 22px;
		font-weight: bold;
	}

	.navigation .v-btn--active:before {
		opacity: 0;
	}

	.link {
		color: #0694d4;
	}

	.navigation .v-btn--active {
		border-bottom: 2px solid;
		border-radius: 0;
		color: #2f5dab;
		border-color: #2f5dab;
	}

	.navigation .v-btn--active .link {
		color: #2f5dab;
		border-color: #2f5dab;
	}

	.block {
		display: inline-block
	}

	.v-toolbar {
		box-shadow: unset
	}

</style>
